import { defineMessages } from 'react-intl';

export default defineMessages({
  pleaseWait: {
    id: 'components.loading.pleaseWait',
    defaultMessage: 'Loading…',
  },
});



// WEBPACK FOOTER //
// ./src/components/Loading/messages.js